import type { ReferenceField, TaxonomyEntity } from '@uncinc/react-drupal-core/types';

import type { QuicklinksProps } from '.';

function taxonomyQuicklinksMapper(taxonomies: ReferenceField<TaxonomyEntity>[]): QuicklinksProps['links'] {
  return taxonomies.map((term) => {
    const name = term.entity.name[0].value;
    const slug = name.replace(/ /g, '-').toLowerCase();

    return {
      link: `#${slug}`,
      title: name,
    };
  });
}

export default taxonomyQuicklinksMapper;
